<script setup lang="ts">
import { useRoute } from 'vue-router';
import AppShell from '@/components/shell/AppShell.vue';
import { useSessionStore } from '@/stores/session.store';

// `/ds` (vitrine do Design System) fica fora do shell. Rotas públicas ficam fora do shell
// somente SEM sessão; com sessão (ex.: /privacidade acessada logado), o shell é mantido —
// auditoria ALTA #2.
const route = useRoute();
const { session } = useSessionStore();
</script>

<template>
  <AppShell
    v-if="route.meta.standalone !== true && (route.meta.public !== true || session.user !== null)"
  />
  <RouterView v-else />
</template>
